import { DeleteVehicleMutation } from "../../../generatedQueries";
import {
  Event,
  ConstructorArgs as EventConstructorArgs,
} from "../../core/Event";
import { EventCategories } from "../../event-categories";
import { EventSubCategories } from "../../event-sub-categories";

export type Data = {
  deletedVehicleId?: number;
};

export type ConstructorArgs = {
  mutationResponse: DeleteVehicleMutation["deleteVehicle"];
} & Partial<EventConstructorArgs>;

class DeleteVehicleResponse extends Event<Data> {
  public constructor(args: ConstructorArgs) {
    const { mutationResponse, ...baseArgs } = args;

    super({
      ...baseArgs,
      category: EventCategories.UI,
      subCategory: EventSubCategories.VEHICLES,
      type: `DELETE_VEHICLE.RESPONSE`,
      data: {
        deletedVehicleId: mutationResponse?.deletedVehicleId,
      },
    });
  }
}

export { DeleteVehicleResponse };
